// extracted by mini-css-extract-plugin
export default {"videoLoopWrap":"VideoLoopSelector_videoLoopWrap__u6vi8"};